const GC_FIT_DIRECT_DEFAULT_FLAG = '__geekcidentFitDirectDefaultV1';

if (!window[GC_FIT_DIRECT_DEFAULT_FLAG]) {
  window[GC_FIT_DIRECT_DEFAULT_FLAG] = true;

  const goToDefaultVariant = (variantId) => {
    if (!variantId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', String(variantId));

    window.location.assign(url.toString());
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const input = target.closest(
        'input[type="radio"][data-gc-fit-default-variant]'
      );
      if (!input) return;

      const variantId = input.dataset.gcFitDefaultVariant;
      if (!variantId) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      goToDefaultVariant(variantId);
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLSelectElement)) return;

      const selected = target.options[target.selectedIndex];
      const variantId = selected?.dataset?.gcFitDefaultVariant;
      if (!variantId) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      goToDefaultVariant(variantId);
    },
    true
  );
}